/**
 * infinite-scroll.js — Sam's Store UAE  v3
 * Fixed to use Dawn's actual pagination structure:
 *   Next page = .pagination__item-arrow:last-of-type (last arrow in pagination list)
 *   No rel="next" attribute used by Dawn.
 */
(function () {
    'use strict';

    var SELECTOR_GRID = '#product-grid';
    var totalShown = 0;

    /* Dawn's pagination: the "next page" arrow is the LAST .pagination__item-arrow link */
    function getNextUrl() {
        var arrows = document.querySelectorAll('.pagination__item-arrow');
        if (!arrows.length) return null;
        var last = arrows[arrows.length - 1];
        /* Make sure it's actually a "next" arrow (not the prev arrow when only one exists) */
        /* When there IS a prev, there are 2 arrows. When no prev, only 1 arrow (= next) */
        /* Safest: if the pagination wrapper shows current page < total pages */
        var wrapper = document.querySelector('.pagination-wrapper');
        if (!wrapper) return null;
        var currentPage = parseInt(wrapper.getAttribute('data-page') || '1', 10);
        /* Not all Dawn themes set data-page — fall back to href containing "page=" */
        var href = last.getAttribute('href');
        if (!href) return null;
        /* Verify it's a next-page link by checking it goes to page > current */
        if (href.indexOf('page=') === -1) return null;
        var m = href.match(/page=(\d+)/);
        if (!m) return null;
        var linkPage = parseInt(m[1], 10);
        if (linkPage <= currentPage) return null; // it's the prev arrow
        return href;
    }

    function updateProgress(count) {
        var bar = document.getElementById('sam-is-progress');
        if (bar) bar.textContent = 'Showing ' + count + ' products';
    }

    /* ── Fix #3: Skeleton cards helper ── */
    function createSkeletonCard() {
        var li = document.createElement('li');
        li.className = 'grid__item sam-skeleton-item';
        li.setAttribute('aria-hidden', 'true');
        li.innerHTML = '<div class="sam-skeleton-card">'
            + '<div class="sam-skeleton-card__image"></div>'
            + '<div class="sam-skeleton-card__line"></div>'
            + '<div class="sam-skeleton-card__line sam-skeleton-card__line--short"></div>'
            + '</div>';
        return li;
    }

    function injectSkeletons(grid, count) {
        var frags = [];
        for (var i = 0; i < count; i++) {
            var sk = createSkeletonCard();
            grid.appendChild(sk);
            frags.push(sk);
        }
        return frags;
    }

    function removeSkeletons(skeletons) {
        skeletons.forEach(function(sk){ if(sk.parentNode) sk.parentNode.removeChild(sk); });
    }

    function showSpinner(show) {
        var sentinel = document.getElementById('infinite-scroll-sentinel');
        if (!sentinel) return;
        sentinel.innerHTML = show
            ? '<div class="infinite-scroll__spinner" role="status"><span></span><span></span><span></span></div>'
            : '';
    }

    function fetchPage(url) {
        var grid = document.querySelector(SELECTOR_GRID);
        var skeletons = grid ? injectSkeletons(grid, 4) : [];
        showSpinner(true);
        fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (html) {
                removeSkeletons(skeletons);
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var newItems = doc.querySelectorAll(SELECTOR_GRID + ' > li, ' + SELECTOR_GRID + ' > .grid__item');

                if (grid && newItems.length > 0) {
                    newItems.forEach(function (item) { grid.appendChild(item); });
                    totalShown += newItems.length;
                    updateProgress(totalShown);
                    document.dispatchEvent(new CustomEvent('infinite-scroll:products-added', { detail: { count: newItems.length } }));
                }

                /* Update pagination: replace entire nav so getNextUrl() re-reads correctly */
                var newPaginationWrap = doc.querySelector('.pagination-wrapper');
                var oldPaginationWrap = document.querySelector('.pagination-wrapper');
                if (oldPaginationWrap && newPaginationWrap) {
                    oldPaginationWrap.outerHTML = newPaginationWrap.outerHTML;
                } else if (oldPaginationWrap && !newPaginationWrap) {
                    oldPaginationWrap.remove();
                }

                showSpinner(false);
                observe();
            })
            .catch(function () { removeSkeletons(skeletons); showSpinner(false); });
    }

    function observe() {
        var sentinel = document.getElementById('infinite-scroll-sentinel');
        if (!sentinel) return;

        var nextUrl = getNextUrl();
        if (!nextUrl) { sentinel.style.display = 'none'; return; }
        sentinel.style.display = '';

        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) { io.disconnect(); fetchPage(nextUrl); }
            });
        }, { rootMargin: '400px' });

        io.observe(sentinel);
    }

    function init() {
        var grid = document.querySelector(SELECTOR_GRID);
        if (!grid) return;

        var paginationWrap = document.querySelector('.pagination-wrapper');
        if (!paginationWrap) return;

        totalShown = grid.querySelectorAll('li, .grid__item').length;

        /* Progress bar above pagination */
        var bar = document.createElement('div');
        bar.id = 'sam-is-progress';
        bar.className = 'sam-is-progress';
        bar.setAttribute('aria-live', 'polite');
        bar.textContent = 'Showing ' + totalShown + ' products';
        paginationWrap.parentNode.insertBefore(bar, paginationWrap);

        /* Sentinel after pagination */
        var sentinel = document.createElement('div');
        sentinel.id = 'infinite-scroll-sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        paginationWrap.parentNode.insertBefore(sentinel, paginationWrap.nextSibling);

        observe();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
